import React, { useEffect, useState, useRef } from 'react';
interface BeforeAfterSliderProps {
  beforeImage: string;
  afterImage: string;
  beforeLabel?: string;
  afterLabel?: string;
}
export function BeforeAfterSlider({
  beforeImage,
  afterImage,
  beforeLabel = 'Before',
  afterLabel = 'After'
}: BeforeAfterSliderProps) {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const handleMove = (clientX: number) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const percentage = x / rect.width * 100;
    setSliderPosition(Math.min(Math.max(percentage, 0), 100));
  };
  const handlePointerDown = (e: React.PointerEvent) => {
    setIsDragging(true);
    handleMove(e.clientX);
    e.currentTarget.setPointerCapture(e.pointerId);
  };
  const handlePointerMove = (e: React.PointerEvent) => {
    if (!isDragging) return;
    handleMove(e.clientX);
  };
  const handlePointerUp = (e: React.PointerEvent) => {
    setIsDragging(false);
    e.currentTarget.releasePointerCapture(e.pointerId);
  };
  return <div ref={containerRef} className="relative w-full aspect-[4/3] overflow-hidden rounded-2xl bg-stone-100 select-none touch-none cursor-ew-resize" onPointerDown={handlePointerDown} onPointerMove={handlePointerMove} onPointerUp={handlePointerUp} data-id="element-90">
      {/* After Image (full width) */}
      <div className="absolute inset-0" data-id="element-91">
        <img src={afterImage} alt={afterLabel} className="w-full h-full object-cover" draggable={false} data-id="element-92" />
        <div className="absolute top-4 right-4 bg-forest-900/80 text-white px-3 py-1.5 rounded-full text-xs font-medium backdrop-blur-sm" data-id="element-93">
          {afterLabel}
        </div>
      </div>

      {/* Before Image (clipped) */}
      <div className="absolute inset-0 overflow-hidden" style={{
      width: `${sliderPosition}%`
    }} data-id="element-94">
        <img src={beforeImage} alt={beforeLabel} className="w-full h-full object-cover" style={{
        width: containerRef.current?.offsetWidth || '100%'
      }} draggable={false} data-id="element-95" />
        <div className="absolute top-4 left-4 bg-stone-700/80 text-white px-3 py-1.5 rounded-full text-xs font-medium backdrop-blur-sm" data-id="element-96">
          {beforeLabel}
        </div>
      </div>

      {/* Slider Handle */}
      <div className="absolute top-0 bottom-0 w-1 bg-white shadow-lg" style={{
      left: `${sliderPosition}%`,
      transform: 'translateX(-50%)'
    }} data-id="element-97">
        {/* Circular Grip */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-xl border-2 border-forest-600 flex items-center justify-center" data-id="element-98">
          <div className="flex gap-0.5" data-id="element-99">
            <div className="w-0.5 h-4 bg-forest-600 rounded-full" data-id="element-100"></div>
            <div className="w-0.5 h-4 bg-forest-600 rounded-full" data-id="element-101"></div>
          </div>
        </div>
      </div>
    </div>;
}